import { render, staticRenderFns } from "./boards.vue?vue&type=template&id=1a47a7e3"
import script from "./boards.vue?vue&type=script&lang=js"
export * from "./boards.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./boards.vue?vue&type=style&index=1&id=1a47a7e3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports